import "./es.array.map-d821aaf5.js";
import "./es.array.reduce-2985ed2c.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import { QUERIES as p } from "@ucl/shared-component-foundations";
import i from "react";
import m from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as T } from "./getMetrics-953aa4f8.js";
import { AspectRatio as G } from "./aspectRatio.js";
import { c as a } from "./childrenCountCheck-bbe924c6.js";
import { jsxs as P, Fragment as $, jsx as c } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-is-node-a035d787.js";
import "./environment-ddee5959.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./classof-21a3574e.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-apply-4756dee6.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.join-c1bca812.js";
import "./species-constructor-00346775.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./index-8b07dec9.js";
var g = /* @__PURE__ */ m.div.withConfig({
  displayName: "photoGalleryThumbnail__PhotoGalleryThumbnailContainer",
  componentId: "sc-1woojb5-0"
})(["width:", ";height:", ";display:", ";flex-direction:", ";gap:", ";flex-wrap:", ";@media ", "{flex-wrap:", ";}"], function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailContainer.width;
}, function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailContainer.height;
}, function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailContainer.display;
}, function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailContainer.flexDirection;
}, function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailContainer.gap;
}, function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailContainer.flexWrap;
}, p.tabletAndUp, function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailContainer.tabletAndUp.flexWrap;
}), _ = function(o, l) {
  var t = {
    "33-3": "calc(50% - 12px)",
    "33-2": "100%",
    "25-4": "calc(50% - 12px)",
    "25-3": "100%",
    "50-3": "100%",
    "50-2": "calc(50% - 12px)",
    "66-2": "100%",
    "66-1": "100%",
    100: "100%"
  };
  return t[o + "-" + l] || t["" + o] || "auto";
}, x = function(o, l) {
  var t = {
    "25-4": "25%",
    "25-3": "calc(25% - 12px)",
    "50-3": "50%",
    "50-2": "50%",
    "33-2": "calc(33.5% - 15px)",
    "33-3": "33.33%",
    "66-2": "calc(66.5%)",
    100: "100%"
  };
  return t[o + "-" + l] || t["" + o];
}, d = /* @__PURE__ */ m.div.withConfig({
  displayName: "photoGalleryThumbnail__PhotoGalleryThumbnailWrapper",
  componentId: "sc-1woojb5-1"
})(["width:", ";display:", ";flex-direction:", ";gap:", ";img{transition:", ";&:hover{transform:", ";}}@media ", "{flex-direction:", ";width:", ";", " ", "}"], function(e) {
  return x((e == null ? void 0 : e.$size) || 100, e.$count || 1);
}, function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailWrapper.display;
}, function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailWrapper.flexDirection;
}, function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailWrapper.gap;
}, function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailAspectRatio.img.transition;
}, function(e) {
  var o;
  return e.$disableHoverZoom ? "none" : e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailAspectRatio.img.hover.transform;
}, p.mobile, function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailWrapper.mobile.flexDirection;
}, function(e) {
  return _(e.$size || 100, e.$count || 1);
}, function(e) {
  return e.$size === 33 && e.$count === 3 && `
      &:nth-child(3) {
        width: 100%;
      }
    `;
}, function(e) {
  return e.$size === 66 && e.$count === 2 && `
      &:nth-child(2) {
        width: 100%;
      }
    `;
}), C = /* @__PURE__ */ m(G).withConfig({
  displayName: "photoGalleryThumbnail__PhotoGalleryThumbnailAspectRatio",
  componentId: "sc-1woojb5-2"
})(["border-radius:", ";overflow:", ";gap:", ";height:", ";"], function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailAspectRatio.borderRadius;
}, function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailAspectRatio.overflow;
}, function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailAspectRatio.gap;
}, function(e) {
  var o;
  return e == null || (o = e.theme) == null ? void 0 : o.components.photoGalleryThumbnail.PhotoGalleryThumbnailAspectRatio.height;
}), w = function(o) {
  var l = o.children;
  return /* @__PURE__ */ c(C, {
    ratio: "16/9",
    objectFit: "fill",
    children: l
  });
}, W = {
  25: 2,
  33: 2,
  50: 1,
  66: 1,
  100: 1
}, s = function(o) {
  var l = o.children, t = o.size, h = o.disableHoverZoom, b = h === void 0 ? !1 : h, v = T({
    label: "PhotoGalleryThumbnail"
  }), y = t.reduce(function(n, r) {
    return n + r;
  }, 0) <= 100, f = i.Children.map(l, function(n, r) {
    var u;
    return a({
      children: n == null || (u = n.props) == null ? void 0 : u.children,
      maxChildren: W[t[r]],
      componentName: "PhotoGalleryThumbnail.Wrapper",
      additionalInfo: "Please remove the extra PhotoGalleryThumbnail.Item children from inside the PhotoGalleryThumbnail.Wrapper"
    }), /* @__PURE__ */ i.isValidElement(n) && n.type === d ? /* @__PURE__ */ i.cloneElement(n, Object.assign({}, {
      $size: t[r],
      $disableHoverZoom: b,
      $count: t.length
    })) : "invalid element";
  });
  return a({
    children: l,
    componentName: "PhotoGalleryThumbnail",
    maxChildren: t.length
  }), /* @__PURE__ */ P($, {
    children: [a({
      children: l,
      componentName: "PhotoGalleryThumbnail",
      maxChildren: t.length,
      additionalInfo: "Please remove the extra PhotoGalleryThumbnail.Wrapper children from inside the PhotoGalleryThumbnail"
    }), /* @__PURE__ */ c(g, Object.assign({}, v, {
      children: y ? f : "Unsupported ratio, please use a supported ratio whose sum does not exceed 100. Examples: [25,50,25] or [33,66]"
    }))]
  });
};
s.Wrapper = d;
s.Item = w;
export {
  s as PhotoGalleryThumbnail
};
